module.exports = __webpack_public_path__ + "img/tree-06-f-leaves.a4996662.png";